import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPaymentAfterpay = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	id: "payment-afterpay_icon",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#B2FCE4",
		d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M18.845 7.78 16.63 6.512l-2.248-1.287c-1.485-.851-3.342.218-3.342 1.934v.288c0 .16.083.308.224.384l1.043.596a.432.432 0 0 0 .647-.378v-.685c0-.34.365-.55.66-.384l2.049 1.178 2.043 1.172a.439.439 0 0 1 0 .762l-2.043 1.172-2.05 1.178a.442.442 0 0 1-.659-.384v-.34c0-1.716-1.857-2.792-3.342-1.934L7.37 11.078l-2.215 1.268c-1.492.858-1.492 3.016 0 3.874l2.215 1.268 2.248 1.287c1.486.852 3.343-.218 3.343-1.934v-.288a.43.43 0 0 0-.225-.384l-1.043-.596a.432.432 0 0 0-.647.378v.685c0 .34-.365.55-.66.384l-2.049-1.178-2.042-1.172a.44.44 0 0 1 0-.762l2.042-1.172 2.05-1.178a.442.442 0 0 1 .659.384v.34c0 1.716 1.857 2.792 3.343 1.934l2.247-1.287 2.216-1.268c1.485-.865 1.485-3.023-.007-3.88Z"
	})]
});
export { SvgPaymentAfterpay as ReactComponent };
